/* global google */
import React, { Component } from 'react'
import { withScriptjs } from 'react-google-maps'

// Components
import Map from './Map'
import Loader from '../Loader'

class LocationMap extends Component {
    constructor(props){
        super(props)
        this.state = {
            results: null,
            error: null,
            loading: true
        }
    }

    componentDidMount(){
        // Set state with google script object, and the geocoder for fast access
        this.setState({
            google: google,
            geocoder: new google.maps.Geocoder()
        }, () => {
            this.lookupAddress()
        })
    }

    lookupAddress(){
        this.state.geocoder.geocode({
            'address': this.props.address
        }, (results, status) => {
            // console.log(results)
            // Success
            if(status === this.state.google.maps.GeocoderStatus.OK) {
                this.setState({
                    results: results.length ? results[0] : null,
                    loading: false
                })
            
            // Error
            }else{
                this.setState({
                    error: 'Error:' + status,
                    loading: false
                })
            }
        })
    }

    formatHTMLAddress(address){
        // Split addresses at commas, and bold the first entry (title of the location)
        return address.split(`, `).map((item, i) =>
            <div key={i} style={i === 0 ? { fontWeight: `bold`, paddingBottom: `0.5rem` } : {} }>{item}</div>
        )
    }

    render() {
        return (
            <div>
                {this.state.loading &&
                    <Loader />
                }

                {!!this.state.error &&
                    <div className='error'>{this.state.error}</div>
                }

                {!this.state.loading && !this.state.results && !this.state.error &&
                    <div>Unable to display map</div>
                }

                {!this.state.loading && this.state.results &&
                    <Map
                        containerElement={<div style={{ height: `400px` }} />}
                        mapElement={<div style={{ height: `100%` }} />}
                        zoom={14}
                        location={
                            {
                                lat: this.state.results.geometry.location.lat(),
                                lng: this.state.results.geometry.location.lng(),
                                obj: this.state.results.geometry.location
                            }
                        }
                        markers={
                            [
                                {
                                    lat: this.state.results.geometry.location.lat(),
                                    lng: this.state.results.geometry.location.lng(),
                                    txt: this.formatHTMLAddress(this.state.results.formatted_address)
                                }
                            ]
                        }
                    />
                }
            </div>
        )
    }
}

export default withScriptjs(LocationMap)



// WEBPACK FOOTER //
// ./src/components/utils/maps/LocationMap.js